module.exports = __webpack_public_path__ + "assets/icons/additional-item.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/additional-item.png
// module id = ./src/styles/icons/additional-item.png
// module chunks = 0